import axios from 'axios';
import { API_URL } from '../../../../lib/const';


export const deleteInvite = (invite) => (
  axios.delete(`${API_URL}/invites/${invite}`)
    .then(response => response.data)
);
